import { BoxWrapper, Button, Modal } from 'components/Base';
import { Typography } from '@material-ui/core';

import React from 'react';
import { getRiskDescription } from 'utils';

const RiskDescriptionModal = ({
  score,
  isOpen,
  setIsOpen,
  riskDescription
}: {
  score: number;
  isOpen: boolean;
  setIsOpen: Function;
  riskDescription?: Function | any;
}) => {
  if (!riskDescription) {
    riskDescription = getRiskDescription(score);
  }

  return (
    <Modal isOpen={isOpen} closeModalFunc={() => setIsOpen(false)}>
      <BoxWrapper
        style={{
          height: '100%',
          boxShadow: 'none'
        }}
        title={riskDescription && riskDescription.risk_name}
        closeModal={() => setIsOpen(false)}
      >
        <Typography
          variant="body1"
          component="p"
          style={{ padding: '1rem', maxHeight: '80vh', overflow: 'auto' }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: riskDescription && riskDescription.description
            }}
          ></div>
        </Typography>
        <div style={{ padding: '1rem', paddingTop: 0 }}>
          <Button
            color="primary"
            type="button"
            onClick={() => setIsOpen(false)}
          >
            Close
          </Button>
        </div>
      </BoxWrapper>
    </Modal>
  );
};

export default RiskDescriptionModal;
